import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { AnalyticsBrowser } from '@segment/analytics-next';
import { useLocalization } from '~/composables/_next/useLocalization';
import { useUser } from '~/composables/_next/useUser';
import { AZ_COUNTRY_COOKIE } from '~/constants/localization';
import { useAxeptio } from '~/composables/_next/useAxeptio';
var analytics = new AnalyticsBrowser();
var loaded = false;
var sessionStartTime = ref();
export function useSegment() {
  var _useNuxt2App = useNuxt2App(),
    $sentry = _useNuxt2App.$sentry;
  var _useLocalization = useLocalization(),
    country = _useLocalization.country,
    locale = _useLocalization.locale,
    currency = _useLocalization.currency;
  var _useUser = useUser(),
    isAuthenticated = _useUser.isAuthenticated;
  var countryBasedOnIp = useCookie(AZ_COUNTRY_COOKIE);
  var _useRuntimeConfig = useRuntimeConfig(),
    _useRuntimeConfig$pub = _useRuntimeConfig.public,
    domain = _useRuntimeConfig$pub.domain,
    writeKey = _useRuntimeConfig$pub.segmentWriteKey;
  var route = useRoute();
  var _useAxeptio = useAxeptio(),
    getConsentContext = _useAxeptio.getConsentContext;

  /**
   * Loads Segment script.
   */
  function loadSegment() {
    if (process.server) {
      throw new Error('Segment is only available client side');
    }
    if (loaded || !writeKey) {
      return analytics;
    }
    var subdomain;
    if (domain) {
      try {
        var url = new URL(domain);
        subdomain = url.hostname;
      } catch (error) {
        $sentry.captureException(error);
      }
    }

    // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/cookie-validity-update/#storage-priority
    analytics = analytics.load({
      writeKey: writeKey
    }, {
      cookie: {
        domain: subdomain,
        secure: process.env.NODE_ENV === 'production'
      },
      storage: {
        stores: ['cookie', 'localStorage', 'memory']
      }
    });
    loaded = true;
    analytics.catch(function (error) {
      $sentry.captureException(error);
    });
    window.analytics = analytics;
    return analytics;
  }
  var pageCategory = ref();
  var commonProperties = computed(function () {
    return {
      context: {
        shipping_country: country,
        store_currency: currency,
        store_locale: locale,
        is_logged_in: isAuthenticated.value,
        page_category: pageCategory.value
      }
    };
  });
  function track(event) {
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var consentContext = getConsentContext();
    analytics.track(event, _objectSpread(_objectSpread({}, properties), commonProperties.value), consentContext);
  }
  function trackPage(category, name) {
    var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    pageCategory.value = category;
    var consentContext = getConsentContext();
    analytics.page(category, name, _objectSpread(_objectSpread(_objectSpread({}, properties), {}, {
      path: route.fullPath
    }, commonProperties.value), {}, {
      context: _objectSpread(_objectSpread({}, commonProperties.value.context), {}, {
        is_landing: sessionStartTime.value ? Date.now() - sessionStartTime.value.getTime() > 30 * 60 * 1000 // 30 minutes
        : true,
        country_based_on_ip: countryBasedOnIp.value
      }),
      consentContext: consentContext
    }));
    sessionStartTime.value = new Date(); // Reset session start time on page view
  }
  return {
    analytics: analytics,
    loadSegment: loadSegment,
    track: track,
    trackPage: trackPage
  };
}